import { Box, Button, ButtonsGroup, Grid, InputText } from "@/components/atoms";
import { FC, memo, useState } from "react";
import { DESKTOP_SPACING } from "@/theme";
import EditPackageService from "./EditPackageService";
import { EditTemplateProps } from "./EditPackage.interface";
import { useInput } from "@/hooks";

const EditPackage: FC<EditTemplateProps> = ({
    orderTemplate,
    onCancel,
    onSaveTemplate
}) => {

    const description = useInput(orderTemplate.description);
    const price = useInput(orderTemplate.price.toString());
    const orderOfferPrice = useInput(orderTemplate.orderOfferPrice?.toString() ?? null);
    const floorAreaSurchargeThreshold = useInput(orderTemplate.floorAreaSurchargeThreshold?.toString() ?? null);
    const floorAreaSurchargeAmount = useInput(orderTemplate.floorAreaSurchargeAmount?.toString() ?? null);
    const virtualTourImagesThreshold = useInput(orderTemplate.virtualTourImagesThreshold?.toString() ?? null);
    const virtualTourImagesSurchargeAmount = useInput(orderTemplate.virtualTourImagesSurchargeAmount?.toString() ?? null);

    const [services, setServices] = useState(orderTemplate.services);

    const handleServiceChange = (id: string, defaultAmount: number) => {
        setServices((prev) =>
            prev.map((p) => (p.orderTypeId === id ? {...p, checked: defaultAmount > 0, defaultAmount } : p))
        );
    }

    const handleSaveTemplate = () => {
        onSaveTemplate({
            customerId: orderTemplate.customerId,
            description: description.value,
            floorAreaSurchargeAmount: floorAreaSurchargeAmount.value ? Number(floorAreaSurchargeAmount.value) : null,
            floorAreaSurchargeThreshold: floorAreaSurchargeThreshold.value ? Number(floorAreaSurchargeThreshold.value) : null,
            id: orderTemplate.id,
            isVirtual: orderTemplate.isVirtual,
            orderOfferPrice: Number(orderOfferPrice.value),
            price: Number(price.value),
            services: services,
            virtualTourImagesSurchargeAmount: virtualTourImagesSurchargeAmount.value ? Number(virtualTourImagesSurchargeAmount.value) : null,
            virtualTourImagesThreshold: virtualTourImagesThreshold.value ? Number(virtualTourImagesThreshold.value) : null
        });
    }

    return (<>
        <Grid columnGap={DESKTOP_SPACING.XL} margin={`${DESKTOP_SPACING.XXL}px 0 0`}>
            <InputText type="text" label="Description" value={description.value} onChange={description.onChange} />
            <InputText type="number" label="PriceExVAT" value={price.value} onChange={price.onChange} />
            <InputText type="number" label="Order Offer Price" value={orderOfferPrice.value} onChange={orderOfferPrice.onChange} />
            <InputText type="number" label="Charge extra for floor plans above this sq ft" value={floorAreaSurchargeThreshold.value} onChange={floorAreaSurchargeThreshold.onChange} />
            <InputText type="number" label="Amount to charge per sq ft (GBP/USD)" value={floorAreaSurchargeAmount.value} onChange={floorAreaSurchargeAmount.onChange} />
            <InputText type="number" label="Charge extra for photos above this number" value={virtualTourImagesThreshold.value} onChange={virtualTourImagesThreshold.onChange} />
            <InputText type="number" label="Amount to charge per extra photos (GBP/USD)" value={virtualTourImagesSurchargeAmount.value} onChange={virtualTourImagesSurchargeAmount.onChange} />
        </Grid>
        {services.map((s) => {
            return (<EditPackageService 
                key={s.orderTypeId}
                orderTemplateService={s}
                onServiceChange={handleServiceChange}
                />)
        } )}
        <Box textAlign="right">
            <ButtonsGroup margin="15px 0px">
                <Button buttonColor="primary" actionType="outline" onClick={onCancel}>
                    Cancel
                </Button>
                <Button onClick={handleSaveTemplate}>
                    Save
                </Button>
            </ButtonsGroup>
        </Box>
    </>)
}

export default memo(EditPackage);